import React, { useEffect, useState } from "react";
import MagicTable from "../common/MagicTable";
import Box from "../mui/Box";
import TableHeader from "../common/MagicPageHeader";
import Header from "../common/MagicTableHeader";
import { useFetchParameterWiseReportsQuery } from "../../store/apis/reportsApis";
import DownloadToXlsxFile from "../../helper/DownloadToXlsxFile";
import ImageComponent from "../mui/Image";


interface TabCategory {
  id: number;
  name: string;
  code: string;
}

interface ParameterWiseTableProps {
  selectedTab: TabCategory | null;
  magicTableHeaderBtn: any[];
  params:any;
  isInvalidSearch: boolean;
  onPaginationChange: (pageNo: number) => void;
  onSearch: (searchTerm: string) => void;
}

const ParameterWiseTable: React.FC<ParameterWiseTableProps> = ({
  selectedTab,
  magicTableHeaderBtn,
  params,
  isInvalidSearch,
  onPaginationChange,
  onSearch,
}) => {
  const [downloadParams, setDownloadParams] = useState<any>(null);
  const [downloadTrigger, setDownloadTrigger] = useState(false);
  const filteredParams = { ...params };
  delete filteredParams.quarterMasterId;
  const { data = { totalReports: 0, reports: [] }, isLoading } = useFetchParameterWiseReportsQuery(filteredParams);
  const totalPages = Math.max(1, Math.ceil(data.totalReports / 10));
  const columns = [
    {
      field: "parameter",
      headerName: "Parameter",
      flex: 1,
      minWidth: 250,
      sortable: true,
    },
    {
      field: "centre",
      headerName: "Centre",
      flex: 1,
      minWidth: 300,
      sortable: true,
      renderCell: (params: any) => {
        const centre = params.row.centre || "-";
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              overflowX: "scroll",
              whiteSpace: "nowrap",
              maxWidth: "100%",
              "&::-webkit-scrollbar": {
                width: "0px",
                height: "0px",
              },
            }}
          >
            {centre}
          </Box>
        );
      },
    },
    {
      field: "quarter1",
      headerName: "Q1",
      flex: 1,
      minWidth: 100,
      sortable: true,
      renderCell: (params: any) => {
        return params.row.quarter1 ?? "-";
      },
    },
    {
      field: "quarter2",
      headerName: "Q2",
      flex: 1,
      minWidth: 100,
      sortable: true,
      renderCell: (params: any) => {
        return params.row.quarter2 ?? "-";
      },
    },
    {
      field: "quarter3",
      headerName: "Q3",
      flex: 1,
      minWidth: 100,
      sortable: true,
      renderCell: (params: any) => {
        return params.row.quarter3 ?? "-";
      },
    },
    {
      field: "quarter4",
      headerName: "Q4",
      flex: 1,
      minWidth: 100,
      sortable: true,
      renderCell: (params: any) => {
        return params.row.quarter4 ?? "-";
      },
    },
  ];
  const { data: downloadData ,isLoading: downloadLoading} = useFetchParameterWiseReportsQuery(downloadParams, {
    skip: !downloadParams,
  });
 
  const handleDownload = async() => {
    try {
      const downloadPayload = {
        ...filteredParams,
        pageNo: "1",
        pageSize: data.totalReports || "10",
      };

      setDownloadParams(downloadPayload);
      setDownloadTrigger(true); 

    } catch (error) {
      console.error("Error during download:", error);
    }
  };

  useEffect(() => {
    if (downloadData && downloadTrigger) {
      const sheetData = [
        [
          "Parameter",
          "Centre",
          "Quarter 1",
          "Quarter 2",
          "Quarter 3",
          "Quarter 4",
        ],
        ...(downloadData?.reports.map((report: any) => [
          report.parameter || "-",
          report.centre || "-",
          report.quarter1 || "-",
          report.quarter2 || "-",
          report.quarter3 || "-",
          report.quarter4 || "-",
        ]) || []),
      ];

      DownloadToXlsxFile({
        fileNamePrifix: "parameter-wise-report",
        sheetData,
      });
      setDownloadTrigger(false);  
    }
    }, [downloadData, downloadTrigger]);  
  const magicPageHeaderBtn = [
    {
      text: "Download",
      variant: "outlined",
      startIcon: (
        <ImageComponent
          src="/assets/images/login/exportIcon.svg"
          alt="ExportIcon"
        />
      ),
      onClick: handleDownload,
      loading: downloadLoading,
      sx: {
        background: "white",
        border: "1px solid #D0D5DD",
        borderRadius: "8px",
        color: "black",
      },
    },
  ];
  return (
    <>
      <TableHeader
        title={`${selectedTab?.name || "Parameter wise"} Report`}
        subTitle="Here you can view the report with all the details."
        buttons={magicPageHeaderBtn}
        chipLabel={`${data?.totalReports} entries`}
      />
      <Header
        buttons={magicTableHeaderBtn}
        onSearchfieldChange={(value) => onSearch(String(value))}
        isInvalidSearch={isInvalidSearch}
      />
      <MagicTable
        columns={columns}
        rows={data?.reports}
        loading={isLoading}
        currentPage={parseInt(params?.pageNo) || 1}
        handlePageChange={(event, pageNo) => onPaginationChange(pageNo)}
        count={totalPages}
        rowCellsSx={{ paddingLeft: "16px", textAlign: "start" }}
        headerSx={{
          paddingLeft: "16px",
          textAlign: "start",
          fontWeight: 600,
          color: "#242424",
          padding: "13px 16px",
        }}
        tableSx={{ minHeight: "300px", width: "100%" }}
        sx={{
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#DADADA",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 550,
            fontSize: "14px",
          },
          "& .MuiDataGrid-row": {
            backgroundColor: "#FFFFFF",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#FFFFFF",
          },
          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
          },
        }}
      />
    </>
  );
};

export default ParameterWiseTable;
